exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legacy-migration-submit[data-v-6bc2799e] {\n  font-weight: 600;\n  -webkit-box-shadow: 0 4px 10px rgba(230, 162, 60, 0.28);\n          box-shadow: 0 4px 10px rgba(230, 162, 60, 0.28);\n}\n.other-login[data-v-6bc2799e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.other-login span[data-v-6bc2799e] {\n    width: 36px;\n    height: 36px;\n}\n", ""]);

// exports
